import {
  ExpressionCondition,
  ExpressionContainer,
} from '../../../../../backend-core-lib/cross-lib';
import { get } from 'lodash';

export function evaluateFormlyExpression(
  model: any,
  expressionContainer: ExpressionContainer,
): boolean {
  if (expressionContainer.setting === 'NEVER') {
    return false;
  } else if (expressionContainer.setting === 'ALWAYS') {
    return true;
  }
  const negativeCond = expressionContainer.setting === 'ONLYIFNOT';
  const conditions = expressionContainer.expressionConditions || [];
  let conditionOK = expressionContainer.joinCondition === 'AND';

  for (let indexCond = 0; indexCond < conditions.length; indexCond++) {
    const condition = conditions[indexCond];

    const conditionResult = evaluateFormlyCondition(model, condition);
    if (!conditionResult && expressionContainer.joinCondition === 'AND') {
      conditionOK = false;
      break;
    } else if (conditionResult && expressionContainer.joinCondition === 'OR') {
      conditionOK = true;
      break;
    }
  }

  return negativeCond ? !conditionOK : conditionOK;
}

function evaluateFormlyCondition(
  model: any,
  expressionCondition: ExpressionCondition,
): boolean {
  if (expressionCondition.expressionContainer) {
    return evaluateFormlyExpression(
      model,
      expressionCondition.expressionContainer,
    );
  }

  const expCheck = expressionCondition.expressionCheck;
  let leftValue = undefined;
  switch (expCheck.operandLeftType) {
    case 'VALUE':
      leftValue = expCheck.operandLeftValue;
      break;
    case 'PATH':
    default:
      leftValue = get(model, expCheck.operandLeftValue, undefined);
      break;
  }
  let rightValue = expCheck.operandRightValue;

  switch (expCheck.operator) {
    case 'EQUALS':
      return leftValue === rightValue || leftValue + '' === rightValue + '';
    case 'NOTEQUALS':
      return !(leftValue === rightValue || leftValue + '' === rightValue + '');
    case 'CONTAINSTEXT':
      return (leftValue + '').indexOf(rightValue + '') >= 0;
    case 'INLIST':
      return (
        (rightValue + '')
          .split(expCheck.valueSeparator ?? ',')
          .indexOf(leftValue + '') !== -1
      );
    case 'NOTINLIST':
      return !(
        (rightValue + '')
          .split(expCheck.valueSeparator ?? ',')
          .indexOf(leftValue + '') !== -1
      );
  }
  return false;
}
